import { useLocation } from 'react-router-dom';

// TODO: This hook should be located in a `@pkg` directory,
// since it is imported throughout the app and not coupled to
// anything `@app` specific. Furthermore, we should consider
// qualifying the `queryParam` by something to more clearly
// tie this to the "Profile preview" (vs some other preview).
export function useIsPreview() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    return queryParams.has('preview');
}
